<button
	type="button"
	mat-stroked-button
	color="primary"
	[disabled]="(uploadProgress$ | async) !== null"
	(click)="uploadFile()"
>
	<mat-progress-bar
		*ngIf="uploadProgress$ | async as progress"
		@slide
		color="accent"
		mode="determinate"
		[value]="progress"
	>
	</mat-progress-bar>
	<ng-content></ng-content>
</button>

<a *ngIf="(uploadedDownloadUrl$ | async) || value as url" [href]="url" class="ml-2 download" bpTargetBlank>
	<mat-icon>download</mat-icon>
</a>

<div *ngIf="(uploadError$ | async) || isExceededAllowedSize" @slide class="error">
	{{ uploadError$ | async }}
	<span *ngIf="isExceededAllowedSize">The maximum allowed size of the file is 15mb</span>
</div>

<input #filePicker type="file" [disabled]="(canUpload$ | async) === false" />
